<template>
<div>
    <div class="show-module">
        <h1>{{ module.module.name }}</h1>
        <p>{{ module.module.description }}</p>
    </div>
    <div class="show-exercise">
        <h4>Déroulé de l'exercice</h4>
        <p>Cet exercice a pour objectif de vous permettre de valider vos nouvelles compétences numériques.</p>
        <p><b>L'exercice n'est pas chronométré</b>, prenez tout votre temps pour bien comprendre la question qui vous est posée, et pour examiner l'eventuelle image qui l'accompagne.</p>
        <p>Pour répondre à une question, selectionnez votre réponse et confirmez la avec le bouton [Valider ma réponse].</p>
        <p>Le module est validé une fois que vous avez correctement répondu à toutes les questions de l'exercice.</p>
        <p>
            Vous disposez d'autant d'essai que nécessaire. <br>
            Si vous n'avez pas correctement répondu à toutes les questions au terme d'un exercice, vous serez invité à consulter le support de formation du module en ligne, afin de mieux comprendre vos erreurs.<br>
            Vous pourrez ensuite recommencer l'exercice afin de répondre aux questions auxquelles vous n'avez pas su répondre la fois précédente.
        </p>
        <p>Vous pouvez quitter l'exercice à tout moment, grâce au bouton [Mettre l'exercice en pause], et le reprendre là où vous l'avez laissé.</p>
        <p>Cliquez sur [Démarrer l'exercice] quand vous êtes prêt.</p>
    </div>
    <div class="button-group">
      <b-button variant="secondary" :to="{ name: 'Dashboard' }">Revenir au tableau de bord</b-button>
      <b-button variant="success" class="text-white" :disabled="isDisabled" :to="{ name: 'Question', params: { id: module.module.id }}">{{ exerciseButtonText }}</b-button>
    </div>
</div>
</template>

<script>
import api from '@/services/api.js'
import Store from '@/store/index.js'
export default {
  computed: {
    isDisabled () {
        let isDisabled = false
        if (this.module.exams[0] && this.module.completion==100) {
            isDisabled = true;
        } else if (this.module.exams[0] && this.module.exams[0].is_ended == true) {
            this.module.exams[0].exam_data.forEach((exam_data) => {
                if (exam_data.course_consulted == false) {
                    isDisabled = true;
                }
            });
        }
        return isDisabled;
    },
    exerciseButtonText () {
        if(this.module.exams[0] && this.module.exams[0].is_ended == false) {
        return "Continuer l'exercice"
        } else {
        return "Démarrer l'exercice"
        }
    }
  },
    name:"HomeExercise",
  data () {
    return {
        module: {
            module: {
                id: parseInt(this.$route.params.id),
                name: '',
            },
            exams:
                {
                    'course_consulted' : false
                }
        },
    }
  },
  created() {
    this.$parent.$parent.setLoading(true, "Chargement de l'exercice")
    api.get('/module/')
    .then(response => {
        this.module = response.data[0][this.module.module.id]
        if(this.module == undefined || (this.module.module.is_plus==true && (Store.getters.getIsPlus()==false || parseInt(Store.getters.getNbModulesCompleted()) < 5))) {
            this.$router.push({name: "Dashboard"})
        }
        this.$parent.$parent.setLoading(false)
    })
  }
}
</script>

<style scoped>
h1 {
  font-weight: bold;
  margin-bottom: 20px;
}
h4 {
    font-weight: 500;
}
.show-module {
    border-bottom: 1px dashed #ccc;
}
.show-exercise {
    margin: 1.2em auto;
}
.button-group {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.btn {
    width: 40%;
    min-height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
</style>